import useTranslationStore from '@/language/useTranslationStore.ts'

export default function Terms() {
    const { t } = useTranslationStore()

    return (
        <div className="border-border-dark bg-surface-dark/95 w-full rounded-xl border p-8 text-center shadow-2xl shadow-black/30 backdrop-blur">
            <h1 className="text-2xl font-bold text-white">
                {t('auth.terms.title')}
            </h1>
            <p className="text-secondary-text mt-2 text-sm">
                {t('auth.terms.placeholder')}
            </p>
        </div>
    )
}
